import React from 'react';
import { Container } from '@mui/material';
import { useCreatePath, Show, TabbedShowLayout, useAuthProvider } from 'react-admin';

import { tabbedContainerStyles } from 'src/styles';

import { ShsReturnButton, WithRole } from 'src/components/common';

import CenterTopToolbar from './components/CenterTopToolbar';
import GeneralCenterInfoTab from './components/GeneralCenterInfoTab';
import DepartmentsInfoTab from './components/DepartmentsInfoTab';
import ClassroomLocationsTab from './components/ClassroomLocationsTab';
import { EducationCentersListRolesGroup } from 'src/constants/centers/centers-roles-helper';
import { AdminGroup } from 'src/constants/roles';

export const EducationalCenterView: React.FC = () => {
    const createPath = useCreatePath();
    const authProvider = useAuthProvider();

    return (
        <Container
            maxWidth={false}
            sx={{
                ...tabbedContainerStyles,
                '& .RaShow-main > .MuiPaper-root .RaTabbedShowLayout-content': {
                    padding: '0'
                }
            }}>
            <WithRole roles={EducationCentersListRolesGroup} orElse={<></>}>
                <ShsReturnButton to={createPath({ resource: 'centers', type: 'list' })} label="Назад до усіх центрів" />
            </WithRole>
            <Show queryOptions={{ meta: { useMock: false } }} actions={<CenterTopToolbar />}>
                <TabbedShowLayout>
                    <TabbedShowLayout.Tab label="Загальна інформація">
                        <GeneralCenterInfoTab />
                    </TabbedShowLayout.Tab>
                    {authProvider?.containsRoles(AdminGroup) && (
                        <TabbedShowLayout.Tab label="Відділення">
                            <DepartmentsInfoTab />
                        </TabbedShowLayout.Tab>
                    )}
                    {authProvider?.containsRoles(AdminGroup) && (
                        <TabbedShowLayout.Tab label="Місця проведення уроків">
                            <ClassroomLocationsTab />
                        </TabbedShowLayout.Tab>
                    )}
                </TabbedShowLayout>
            </Show>
        </Container>
    );
};
